// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__175yf","addWidgetButton":"Header_addWidgetButton__2Y1ly","dashboardTabs":"Header_dashboardTabs__rMNFN","active":"Header_active__2qHYE"};